import type {
  ParsedWordSegmentWithDirection,
  BidiInstance,
  TextDirection,
} from '../types';
import { isRTLLevel } from '../utils/level-utils';

/**
 * Phase 8: Character Mirroring
 *
 * Apply character mirroring (parentheses, brackets) only to RTL words.
 * LTR words in RTL context are NOT mirrored.
 */
export const applyCharacterMirroring = (
  words: Array<ParsedWordSegmentWithDirection>,
  bidi: BidiInstance,
  textDirection: TextDirection,
): Array<ParsedWordSegmentWithDirection> => {
  return words.map(word => {
    if (word.direction !== 'rtl') {
      return word;
    }

    const embeddingLevels = bidi.getEmbeddingLevels(word.data, textDirection);

    let mirroredWord = '';
    for (let i = 0; i < word.data.length; i++) {
      const char = word.data[i];

      const mirroredChar = bidi.getMirroredCharacter(char);

      // Mirror characters that are in RTL context and have a mirrored version
      if (isRTLLevel(embeddingLevels.levels[i]) && mirroredChar) {
        mirroredWord += mirroredChar;
      } else {
        mirroredWord += char;
      }
    }

    return {
      ...word,
      data: mirroredWord,
    };
  });
};
